import { IconPropTypes } from '@/legacy/types';

const FrekuentLogo = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={32}
			height={32}
			viewBox='0 0 32 32'
			fill='none'
			{...props}
		>
			<path
				fill='#27225C'
				fillRule='evenodd'
				d='M31.954 15.98c0 8.825-7.156 15.98-15.98 15.98C7.149 31.96 0 24.806 0 15.98 0 7.156 7.156 0 15.98 0c8.825 0 15.98 7.156 15.98 15.98h-.006Zm-19.89 7.28H6.021v-4.946h19.213v4.946H12.064Zm13.21-12.018V5.39s-2.678 2.542-9.626 4.927c-4.96 1.7-9.626 1.773-9.626 1.773v4.92s4.503 0 9.626-1.31c5.69-1.453 9.626-4.458 9.626-4.458Z'
				clipRule='evenodd'
			/>
		</svg>
	);
};

export default FrekuentLogo;
